<template>
  <div class="app" :class="$route.meta.cssClass">
    <AppHeader fixed :class="getNavClass()">
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <a class="navbar-brand" href="/"><i class="icon nav-icon fa fa-th float-left ml-2 mr-2"></i>
        <img class="navbar-brand-full" src="/img/brand/Harmonie-ESS-Logo.png" height="45" alt="Logo HM Ess" style="padding: 5px;">
      </a>
      <SidebarToggler class="d-md-down-none" display="lg" />

      <b-navbar-nav class="ml-4">
        <div class="input-group" >
          <div class="input-group-prepend">
            <b-form-select v-model="selected" :text="typeSearch" :options="options"></b-form-select>
          </div>
          <b-form-input type="text" id="textSearch" name="textSearch" v-on:keyup.enter="search" v-model="textSearch" placeholder="Rechercher" size="md" autocomplete="off"></b-form-input>
          <b-button type="enter" @click.prevent="search" size="md" variant="primary">
            <i class="fa fa-search"></i>
          </b-button>
          <span class="field-error ml-2">{{ errors.textSearch }}</span>
        </div>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto mr-auto" v-html="getEnvLibelle()"></b-navbar-nav>
      <b-navbar-nav v-if="maintenance" class="ml-auto mr-auto" v-html="maintenance"></b-navbar-nav>
      <b-navbar-nav class="ml-2" v-if="canTakePlaceOf()">
        <b-button variant="warning" v-b-modal.modal-en-tant-que>Se connecter en tant que</b-button>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto" v-if="canComeBackToOriginalProfil()">
        <b-button variant="warning" @click.prevent="getUserBack()">Revenir à mon compte</b-button>
      </b-navbar-nav>
      <b-navbar-nav class="ml-2">
        <i class="fa fa-bell-o ml-2 mr-3 clickable" @click="seeNotifications('active')"><b-badge v-if="nbNotification > 0" variant="danger" pill>{{ nbNotification }}</b-badge></i>
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
    </AppHeader>

    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main position-relative">
        <Breadcrumb :list="list"/>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
          :loader="loader"
          :color="color"
          :background-color="backgroundColor">
        </loading>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>

    <TheFooter>
      <div>
        <a href="https://www.chorum.fr/" target="_blank">HM Ess</a>
        <span class="ml-1">&copy; {{ year }}</span>
      </div>
      <div class="ml-auto" v-if="canAccess(rules.CAN_ACCESS_HISTO_LIVRAISONS)">
        <div @click.prevent="showLivraison(idVersion)" v-html="infosVersion"></div>
      </div>
      <div class="ml-auto" v-else>
        <div v-html="infosVersion"></div>
      </div>
    </TheFooter>

    <b-modal centered id="modal-en-tant-que" ref="modal-en-tant-que" title="Choisissez un collaborateur">
      <b-row class="mb-1">
        <b-col sm="12">
          <b-form-group
            id="fieldset-1"
            description="Choisir le gestionnaire dont on doit prendre la place"
            label="Choisir un collaborateur"
            label-for="gestionnaire"
          >
            <auto-select
                v-model="gestionnaire"
                :items="gestionnaires"
                :loading="loadingGestionnaire"
                item-value="id"
                item-text="nom"
                :placeholder="gestionnaire ? '' : 'Entrer le nom du gestionnaire'"
                disable-filtering-by-search
                @search="onSearchGestionnaire"
                v-on:keyup.enter="onEnter()"
              >
                <template #no-data>
                  {{ noData ? "Aucun gestionnaire trouvé." : "Il faut au moins 2 caractères pour la recherche." }}
                </template>
                <template slot="item" slot-scope="{ item: gest }">
                  <div style="display: flex; align-items: center;" @click="onClick($event, gest)">
                    <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} ({{ gest.profile }}) </span>
                  </div>
                </template>
                <template slot="selection" slot-scope="{ item: gest }">
                  <div style="display: flex; align-items: center;">
                    <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} ({{ gest.profile }})</span>
                  </div>
                </template>
                <template v-if="loadingGestionnaire" #input-end>
                  <img src="https://i.imgur.com/mTNe6tr.gif" class="loading-indicator">
                </template>
              </auto-select>
          </b-form-group>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" @click="changeUser()" class="btn btn-primary"><i class="fa fa-save"></i> Changer de place</button>
        </div>
      </template>
    </b-modal>

    <b-modal scrollable centered size="xl" id="modal-notification" ref="modal-notification" title="Notification">
      <notificationCard :notification="selectedNotification"></notificationCard>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" @click="$bvModal.hide('modal-notification')" class="btn btn-secondary"></i> Fermer</button>
        </div>
      </template>
    </b-modal>

    <b-modal size="lg" scrollable centered id="modal-livraison" ref="modal-livraison" :title="'v ' + versionAtlas + ' du ' + dateVersion">
      <b-row class="mb-1">
        <b-col sm="12">
          <div class="block-livraison" v-html="contenu"></div>
        </b-col>
      </b-row>
      <b-row class="mr-1 ml-1 mb-1 mt-3" v-if="canAccess(rules.CAN_ACCESS_HISTO_LIVRAISONS)">
        <router-link :to="listLivraisons()" target="_blank">
          <i class="fa fa-plus"></i> Voir plus de livraisons
        </router-link>
      </b-row>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" @click="$bvModal.hide('modal-livraison')" class="btn btn-secondary"> Fermer</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import nav from '@/_nav';
import navEspaceBeneficiaire from '@/menu/espace_beneficiaire'
import navAdminGlobal from '@/menu/admin_global'
import navEspaceGestion from '@/menu/espace_gestion'
import navEspaceQualite from '@/menu/espace_qualite'
import navEspaceRPA from '@/menu/espace_rpa'
import navEspaceBibliotheque from '@/menu/espace_bibliotheque'
import navEspaceEmployeur from '@/menu/espace_employeur'
import navEspaceRC from '@/menu/espace_rc'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb, HeaderDropdown } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import {hasRule, rules, sites} from '@/utils/rulesHelper'
import {getCurrentSite, getUser, getVersionBdd} from '@/utils/auth'
import {checkSIREN, isEmpty as isEmptyHelper} from "@/utils/fileHelper";
import {formatDateTime} from "@/utils/communHelper";
import { CoolSelect as AutoSelect } from 'vue-cool-select';
import notificationCard from '@/components/User/NotificationCard';
import Loading from 'vue-loading-overlay';
import { mapState } from 'vuex';

export default {
  name: 'DefaultContainer',
  components: {
    Loading,
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    HeaderDropdown,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    AutoSelect,
    notificationCard
  },
  data () {
    return {
      rules: rules,
      fullPage: false,
      color: '#1b8eb6',
      backgroundColor: 'buttonface',
      loader: 'dots',
      nav: nav.items,
      year : new Date().getFullYear(),
      textSearch : '',
      typeSearch : 'SIREN',
      gestionnaire: '',
      gestionnaireNom: '',
      gestionnairePrenom: '',
      gestionnaires: [],
      loadingGestionnaire: false,
      timeoutId: null,
      noData: false,
      idVersion: '',
      versionAtlas: '',
      contenu: "",
      dateVersion: '',
      infosVersion: '',
      maintenance: false,
      notifications: [],
      userNotifications: [],
      nbNotification: 0,
      notificationTitle: '',
      notificationTime: '',
      notificationMessage: '',
      selectedNotification: {},
      selectedNotificationType: '',
      selectedNotificationMessage: '',
      selectedNotificationTargetType: '',
      selectedNotificationTargetId: '',
      selectedNotificationCommentaire: '',
      selectedNotificationOption: '',
      selectedNotificationDate: '',
      enableNotification: false,
      selected: this.getSelectedPreference(),
      options: [
        { value: 'SIREN', text: 'SIREN' },
        { value: 'NIR', text: 'NIR' },
        { value: 'IDPP', text: 'IDPP NSI' },
        { value: 'Dossier Presta', text: 'Dossier Presta' }
      ],
      errors: {
        textSearch: ''
      }
    }
  },
  created () {
    this.manageNotification(getUser().last_notifications);

    this.$event.on('refreshNbNotification', notifications => {
      this.manageNotification(notifications);
    })
  },
  mounted () {
    // console.log('DefaultContainer.vue mounted() called')
    if(hasRule(rules.ACCESS_ADMIN_GLOBAL) && getCurrentSite() === sites.SETTINGS) {
      this.appendMenu(navAdminGlobal.items)
    }
    if(hasRule(rules.ACCESS_ESPACE_BENEFICIAIRE) && getCurrentSite() === sites.EB) {
      this.appendMenu(navEspaceBeneficiaire.items)
    }
    // console.log(hasRule(rules.ACCESS_ESPACE_GESTION))
    // console.log(getCurrentSite())
    if(hasRule(rules.ACCESS_ESPACE_GESTION) && getCurrentSite() === sites.EG) {
      this.appendMenu(navEspaceGestion.items)
    }
    if(getCurrentSite() === sites.EC) {
      this.appendMenu(navEspaceQualite.items)
    }
    if(hasRule(rules.ACCESS_ESPACE_RPA) && getCurrentSite() === sites.RPA) {
      this.appendMenu(navEspaceRPA.items)
    }
    // console.log('hasRule(rules.CAN_ACCESS_ESPACE_BIBLIOTHEQUE)',hasRule(rules.CAN_ACCESS_ESPACE_BIBLIOTHEQUE),rules.CAN_ACCESS_ESPACE_BIBLIOTHEQUE)
    if(hasRule(rules.CAN_ACCESS_ESPACE_BIBLIOTHEQUE) && getCurrentSite() === sites.EBIBLIO) {
      this.appendMenu(navEspaceBibliotheque.items)
    }
    if(hasRule(rules.ACCESS_ESPACE_EMPLOYEUR) && getCurrentSite() === sites.EEM) {
      this.appendMenu(navEspaceEmployeur.items)
    }
    if(hasRule(rules.ACCESS_ESPACE_RC) && getCurrentSite() === sites.ERC) {
      this.appendMenu(navEspaceRC.items)
    }
    this.getVersionAtlas();

    this.getMaintenance();
    this.isEnableNotification();
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    },
    ...mapState([
      'isLoading'
    ])
  },
  methods: {
    canAccess(rule) {
      return hasRule(rule)
    },
    getSelectedPreference() {
      let searchPreference = getUser().preferences.filter(preference => preference.module === "search_global")
      if (searchPreference !== undefined && searchPreference.length > 0) {
        return searchPreference[0].valeurs
      }
      else {
        return 'SIREN'
      }
    },
    setMenu(menu) {
      this.nav = [];
      for(let i in menu){
        if (!this.childInMenu(menu[i].name)) {
          this.nav.push(menu[i])
        }
      }
    },
    appendMenu(menu) {
      for(let i in menu){
        if (!this.childInMenu(menu[i].name)) {
          this.nav.push(menu[i])
        }
      }
    },
    childInMenu(name){
      let found = false
      for(let i in this.nav){
        if(this.nav[i].name === name){
          found = true
        }
      }
      return found
    },
    search() {
      this.clearErrors();
      if(this.selected === 'SIREN') {
        this.searchSiren();
      }
      if(this.selected === 'NIR') {
        this.searchNir();
      }
      if(this.selected === 'IDPP') {
        this.searchIdpp();
      }
      if(this.selected === 'Dossier Presta') {
        this.searchDossier();
      }
    },
    clearErrors() {
      this.errors.textSearch = '';
    },
    storeSearchType(searchType, savedPreference) {
      let user = this.$store.commit("HANDLE_USER") ? this.$store.commit("HANDLE_USER") : getUser()
      // let user = getUser()
      let searchPreference = user.preferences.filter(preference => preference.module === "search_global")
      if (searchPreference.length > 0) {
        user.preferences.forEach(function(preference){
          if (preference.module === 'search_global') {
            preference.valeurs = searchType
          }
        })
      }
      else {
        user.preferences.push(savedPreference)
      }
      this.$store.commit('FULL_STORE_USER', user)
    },
    saveGestionnaireSearch(searchType) {
      let self = this;
      let data = { 'searchType': searchType }
      this.$axios
        .post('/espaceGestion/gestionnaire-preference/store', data)
        .then((response) => {
          if (getUser().id === getUser().id_original) {
            this.storeSearchType(searchType, response.data)
          }
        })
        .catch((error) => {
          let errorText = 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.'
          if (error.response !== undefined && error.response.status === 409) {
            errorText = error.response.data.message;
          }
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: errorText,
            showConfirmButton: false,
            timer: 5000
          })
        });
    },
    searchSiren() {
      this.textSearch = this.formatNirSiren(this.textSearch);
      if(checkSIREN(this.textSearch)) {
        this.saveGestionnaireSearch(this.selected)

        let currentPath = this.$router.history.current.path;
        let query = {oag: '92063', oap: '92063'}

        this.$router.push({path: "/espace-gestion/sirens/fiche/" + this.textSearch, query: query});
        // Si on est déjà sur la page d'une fiche siren, il faut forcé le rafraichissement de la page, sinon il ne charge pas les données
        if (/espace-gestion\/sirens\/fiche/.test(currentPath)) {
          this.$router.go();
        }
      }
      else {
        this.$swal({
          position: "top",
          type: "error",
          title: "SIREN invalide",
          text: "Veuillez saisir un SIREN valide",
          showConfirmButton: false,
          timer: 4000
        });
      }
    },
    searchNir() {
      this.textSearch = this.formatNirSiren(this.textSearch);
      if(this.$route.params.nir !== this.textSearch) {
        if(this.textSearch.length >= 13 && this.textSearch.length <= 15) {
          this.saveGestionnaireSearch(this.selected)
          let currentPath = this.$router.history.current.path;
          // this.$router.push({path: "/recherche/nir/" + this.textSearch, query: { cssClass: this.$route.meta.cssClass, site: this.$route.meta.site }});
          this.$router.push({path: "/espace-gestion/assures/list", query: {co: '', ns: this.textSearch, cssClass: 'espace-gestion', site: sites.EG }});
          // Si on est déjà sur la page d'un salarié, il faut forcé le rafraichissement de la page, sinon il ne charge pas les données
          if (/recherche\/nir/.test(currentPath)) {
            this.$router.go();
          }
        } else {
          console.log('BAD');
          this.$swal({
            position: "top",
            type: "error",
            title: "NIR invalide",
            text: "Veuillez saisir un NIR valide",
            showConfirmButton: false,
            timer: 4000
          });
        }
      }
    },
    searchIdpp() {
      this.saveGestionnaireSearch(this.selected)
      this.setMenu(navEspaceGestion.items)

      this.$router.push({path: "/espace-gestion/dossier/dashboard", query: { idpp: this.textSearch.trim(), onlyOneCritere: 'idpp', cssClass: 'espace-gestion', site: sites.EG }});
      let currentPath = this.$router.history.current.path;
      // console.log('currentPath',currentPath)
      if (/dossier\/dashboard/.test(currentPath)) {
        this.$router.go();
      }
    },
    searchDossier() {
      if (parseInt(this.textSearch.trim(),10) > 2147483647) {
        this.$swal({
            position: "top",
            type: "error",
            title: "N° de dossier invalide",
            text: 'Le numéro de dossier recherché est invalide, probablement un nir copié dans le champ de recherche',
            showConfirmButton: false,
            timer: 6000
          });
      } else {
        this.saveGestionnaireSearch(this.selected)
        // window.location.href = '/espace-gestion/dossier/dashboard?dossierIds=' + this.textSearch.trim() + '&onlyOneCritere=dossier';
        this.setMenu(navEspaceGestion.items)
        this.textSearch = this.textSearch.trim().replace(/\s/g, '');
        this.textSearch = this.textSearch.replace(/,\s*$/, "");
        var reg = /^[0-9,]+$/;
        if(!reg.test(this.textSearch)){
          this.errors.textSearch = 'Numéro(s) de dossier(s) invalide';
        } else {
          this.$router.push({path: "/espace-gestion/dossier/dashboard", query: { dossierIds: this.textSearch.trim(), onlyOneCritere: 'dossier', cssClass: 'espace-gestion', site: sites.EG }});
          let currentPath = this.$router.history.current.path;
          // console.log('currentPath',currentPath)
          if (/dossier\/dashboard/.test(currentPath)) {
            this.$router.go();
          }
        }

      }
    },
    isEmpty(value) {
      return isEmptyHelper(value);
    },
    formatDate(date) {
      return formatDateTime(date, '-');
    },
    onClick(event, item){
      this.gestionnaireNom = item.nom
      this.gestionnairePrenom = item.prenom
    },
    onEnter(){
      for(let gest of this.gestionnaires) {
        if (this.gestionnaire === gest.id) {
          this.gestionnaireNom = gest.nom
          this.gestionnairePrenom = gest.prenom
        }
      }
    },
    async onSearchGestionnaire(search) {
      let self = this
      const lettersLimit = 2

      this.noData = false
      if (search.length < lettersLimit) {
        this.gestionnaires = []
        this.loadingGestionnaire = false
        return
      }
      this.loadingGestionnaire = true

      clearTimeout(this.timeoutId)
      this.timeoutId = setTimeout(async () => {
        this.$axios
          .get('/espaceGestion/gestionnaire/autocompleteRechercheForLoginAs?query='+search+'&type=all')
          .then(response => {
            // console.log(response)
            this.loadingGestionnaire = false
            this.gestionnaires = response.data
            if (!this.gestionnaires.length) this.noData = true
          })
          .catch(function(error) {
            console.log(error)
            self.loadingGestionnaire = false
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            })
          })
      }, 500)
    },
    async changeUser() {
      this.$store.commit("IS_LOADING", true);
      this.$refs['modal-en-tant-que'].hide();
      await this.$store.dispatch('retrieveUser', this.gestionnaire);
      this.gestionnaire = '';
      this.gestionnaireNom = '';
      this.gestionnairePrenom = '';
      // this.$router.go();
      this.manageNotification(getUser().last_notifications);
      setTimeout(() => {this.$router.go()}, 2000)
    },
    canTakePlaceOf() {
      let user = getUser();
      return user.id === user.id_original && (hasRule(rules.CAN_TAKE_PLACE_OF) || hasRule(rules.CAN_TAKE_PLACE_OF_TEAM) || hasRule(rules.CAN_TAKE_PLACE_ALL_SERVICE));
      // return user.id === user.id_original && (hasRule(rules.CAN_TAKE_PLACE_OF) || hasRule(rules.CAN_TAKE_PLACE_OF_TEAM) || hasRule(rules.CAN_TAKE_PLACE_ALL_SERVICE) || hasRule(rules.CAN_TAKE_PLACE_ALL_TEAM));
    },
    canComeBackToOriginalProfil() {
      let user = getUser();
      return user.id !== user.id_original;
    },
    getUserBack() {
      let user = getUser();
      let userArray = Object.entries(user);
      let userOriginalKeys = userArray.filter(([key,value],index) => key.indexOf('_original') > -1)
      // console.log('userOriginalKeys',userOriginalKeys)
      for (const [key,value] of userOriginalKeys) {
        let initialKey = key.substring(0,(key.length -9));
        // console.log(initialKey)
        user[initialKey] = value;
      }
      // this.$event.emit('refreshToken'); // il faut arriver à attendre que le refreshToken soit fait avant le router.go()
      this.$store.dispatch('setBackUser', user);
      if (this.$router.go()){
        this.selected = user.preferences_original[0].valeurs
      }
    },
    getNavClass() {
      // console.log(process.env)
      return 'env_' + process.env.VUE_APP_ENV;
    },
    getEnvLibelle() {
      if (process.env.VUE_APP_ENV !== undefined && process.env.VUE_APP_ENV !== 'production') {
        let color = '#000000';
        let versionBdd = (getVersionBdd() !== null && getVersionBdd() !== undefined) ? 'BDD : ' + getVersionBdd() : null;
        if (process.env.VUE_APP_ENV === 'developpement' || process.env.VUE_APP_ENV === 'recette') {
          color = 'orange';
        } else {
          color = 'blue';
        }
        if (versionBdd !== null) {
          return `<b style="color: ${color}">Environnement de ` + process.env.VUE_APP_ENV + `</b>&nbsp;<i style="color: ${color};font-size: 0.9em;"> (`+versionBdd+`)</i>`;
        }
        return `<b style="color: ${color}">Environnement de ` + process.env.VUE_APP_ENV + '</b>';
      }
      return '';
    },
    async getMaintenance() {
      // const runtimeConfig = await fetch('/maintenance.json');
      // runtimeConfig.json().then(data => {
      //   if (data.maintenance !== undefined && data.maintenance !== '') {
      //     if (data.message !== undefined && data.message !== '') {
      //       this.maintenance = '<b class="message-maintenance">' + data.message + data.maintenance + '</b>';
      //     } else {
      //       this.maintenance = '<b class="message-maintenance">Attention, Atlas entrera en maintenance à ' + data.maintenance + '</b>';
      //     }
      //   } else {
      //     this.maintenance = false;
      //   }
      // })
      this.maintenance = false;
    },
    formatNirSiren(value) {
      let result = value;
      result = result.toString();
      result = result.replace(/ /g, '');
      result = result.replace(/\./g, '');
      result = result.replace(/-/g, '');
      result = result.replace(/_/g, '');
      return result;
    },
    showLivraison(id) {
      // this.$router.push({ path: '/administration/livraisons/show/' + id })
      // window.location.href = '/administration/livraisons/show/' + id
      // this.$bvModal.show('modal-livraison')
      this.$refs['modal-livraison'].show()
    },
    formatDate(textDate) {
      let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      return date;
    },
    async getVersionAtlas() {
      // const runtimeConfig = await fetch('/version.json');
      // // console.log('runtimeConfig',runtimeConfig)
      // runtimeConfig.json().then(data => {
      //   if (data.version !== undefined && data.version !== '' && data.date_version !== undefined && data.date_version !== '') {
      //     this.versionAtlas = data.version
      //     this.dateVersion = data.date_version
      //   }
      // })

      this.$axios
        .get("/administration/livraisons/last-active-version")
        .then(response => {
          this.versionAtlas = response.data.livraison ? response.data.livraison.numero_version : ''
          this.dateVersion = response.data.livraison ? this.formatDate(response.data.livraison.date_livraison) : ''
          this.idVersion = response.data.livraison ? response.data.livraison.id : null

          if (!this.isEmpty(this.versionAtlas) && !this.isEmpty(this.dateVersion)) {
            if (this.canAccess(this.rules.CAN_ACCESS_HISTO_LIVRAISONS)) {
              this.infosVersion = '<b><a href="#"><span>v ' + this.versionAtlas +'</span></a></b> du ' + this.dateVersion
            } else {
              this.infosVersion = '<b><span>v ' + this.versionAtlas +'</span></b> du ' + this.dateVersion
            }
          } else {
            this.infosVersion = ''
          }
          this.contenu = response.data.livraison ? response.data.livraison.contenu : '';
        })
        .catch((error) => {
          console.log(error)
          this.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Un problème est survenue, merci de contacter l\'administrateur',
            showConfirmButton: false,
            timer: 5000
          })
        });
    },
    listLivraisons() {
      return {
        path: '/last-versions/list'
      }
    },
    async isEnableNotification() {
      // const runtimeConfig = await fetch('/environment.json');
      // runtimeConfig.json()
      //   .then(data => {
      //     if (!isEmptyHelper(data.enable_notification)) {
      //       this.enableNotification = data.enable_notification;
      //     } else {
      //       this.enableNotification = false;
      //     }
      //   })
      this.enableNotification = false;
    },
    countUserNotification() {
      this.nbNotification = 0;
      for (let notification of this.notifications) {
        if (!notification.has_been_seen) {
          this.nbNotification++;
        }
      }
    },
    manageNotification(notifications) {
      this.notifications = notifications;
      // On met à jour les notifications dans user stocké en localStorage pour ne pas perdre les nouvelles données lors d'un refresh
      let user = getUser();
      user.last_notifications = notifications;
      this.$store.commit('FULL_STORE_USER',user);
      // this.userNotifications = _.groupBy(notifications, 'categorie.libelle');
      let groupedByNotification = _.groupBy(notifications, 'categorie.libelle');
      let sortable = Object.entries(groupedByNotification);
      sortable.sort((group1,group2) => group1[1][0].categorie.ordre - group2[1][0].categorie.ordre)

      this.userNotifications = sortable;
      this.countUserNotification();
    },
    showNotification(notification) {
      this.selectedNotification = notification;
      // On change le has_been_seen de la notification si on n'est pas dans le cas d'une connection "en tant que"
      let user = getUser();
      let canUpdate = user.id_original && parseInt(user.id_original,10) !== parseInt(user.id,10) ? false : true;
      if (canUpdate) {
        this.setNotificationAsShown(notification);
      }

      this.$refs['modal-notification'].show();
    },
    getNotificationClass(notification) {
      let cssClass = '';
      switch (notification.categorie.libelle_technique) {
        case 'gestion_prestation':
          cssClass = notification.has_been_seen ? 'notification-blue-light-bg' : 'notification-blue-bg font-weight-bold';
          break;
        case 'systeme':
          cssClass = notification.has_been_seen ? 'notification-orange-light-bg' : 'notification-orange-bg font-weight-bold';
          break;
        default:
          cssClass = '';
      }

      return cssClass;
    },
    setNotificationAsShown(notification) {
      _.each(this.notifications, notif => {
        notif.has_been_seen = notif.id === notification.id ? true : notif.has_been_seen;
      });
      // Do axios
      this.$axios.get('/notification/seen/'+notification.id)
      .then((response) => {
        // console.log('ok');
      })
      .catch((error) => {
        console.log('passage notification en "vue" ko');
      });

      this.manageNotification(this.notifications);
    },
    getUrlTarget(notification) {
      let url = '#';
      let routeData = {};
      switch (true) {
        case /Dossier/.test(notification.target_type) :
          let traitementId = 1; //si pas de type, de forte chance qu'on soit en traitement PFE
          // TODO : voir comment récupérer le traitement de manière dynamique sans plomber les perfs
          if (notification.target && notification.target.type && notification.target.type.groupe.toLowerCase() === 'ij' ) {
            traitementId = 2
          } else if (notification.target && notification.target.type && notification.target.type.groupe.toLowerCase() === 'inval' ) {
            traitementId = 12
          } else if (notification.target && notification.target.type && notification.target.type.groupe.toLowerCase() === 'dc' ) {
            traitementId = 13
          }
          routeData = this.$router.resolve({name: 'fiche dossier', params: { id: notification.target_id }, query: {traitementId: traitementId}});
          url = routeData.href;
          break;
        case /Mail/.test(notification.target_type) :
          routeData = this.$router.resolve({name: 'Réception des mails', params: { id: notification.target_id }});
          url = routeData.href;
          break;
      }

      return url;
    },
    // seeAllNotifications() {
    //   this.$router.push({path: '/administration/notification-user'});
    // },
    seeNotifications(type) {
      this.$router.push({path: '/administration/notification-user/'+type});
      if (/administration\/notification-user/.test(this.$router.history.current.path)) {
        this.$router.go();
      }
    },
    setAllToViewed() {
      for (let notification of this.notifications) {
        if (!notification.has_been_seen) {
          this.setNotificationAsShown(notification);
        }
      }
    }
  }
}
</script>
<style type="text/css">
  .env_developpement {
    background-color: #f8dbbe;
  }
  .env_recette {
    background-color: #edf8be;
  }
  .env_preprod {
    background-color: #bef8ed;
  }
  .dropdown-toggle::after {
    position: absolute;
    top: 49%;
    right: 1em;
  }
  .navbar-nav .dropdown-menu {
    overflow: auto;
    max-height: 500px;
  }
  .notification-footer {
    position: sticky;
    bottom: 0;
  }

</style>
